import {Col, NavDropdown, Row, Nav} from 'react-bootstrap';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import {useNavigate} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';
import './MegaMenu.scss';
import {getAllCategories} from '../../../api/apiClient';

//== Icons
import FB from '../../../assets/icons/facebook.svg';
import TW from '../../../assets/icons/twitter.svg';


const MegaMenu = () => {
    const navigate: any = useNavigate();
    const {data: categories, isLoading, isError, error} = useQuery(
        ['categories'],
        getAllCategories,
        {useErrorBoundary: true}
    );

    let content: any = null;
    if (isLoading) {
        content = Array(33).fill(1).map((_, i) => (
            <li key={i}>
                <SkeletonTheme
                    baseColor="rgba(255, 255, 255, 0.1)"
                    highlightColor="rgba(255, 255, 255, 0.5)"
                    width="90%"
                    height="25px"
                >
                    <Skeleton style={{marginBottom: '12px'}}/>
                </SkeletonTheme>
            </li>
        ));
    }

    if (!isLoading && isError) {
        content = error;
    }

    if (!isLoading && !isError && categories?.length > 0) {
        content = categories?.map((catItem: any) => (
            <li key={catItem?._id}>
                <NavDropdown.Item
                    href="#"
                    onClick={() => navigate(`/category/${catItem?.slug}`, {state: {catName: catItem?.name}})}
                >
                    {catItem?.name}
                </NavDropdown.Item>
            </li>
        ))
    }

    return (
        <div className={'MegaMenuWrap'}>
            <div className="p-3 px-md-4 py-md-3">
                <Row>
                    <Col lg={8} sm={12}>
                        <div
                            className="mmTitle"
                            onClick={() => navigate('/all-categories')}
                        >
                            Categories
                        </div>

                        <ul className={'categoriesItems d-flex align-items-center flex-wrap'}>
                            {content}
                        </ul>
                    </Col>
                    <Col lg={2} sm={6} className={'mt-3 mt-lg-0'}>
                        <div className="mmTitle">
                            About
                        </div>
                        <ul className={'aboutItems'}>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/faq')}>
                                    FAQ
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/about-us')}>
                                    About Us
                                </NavDropdown.Item>
                            </li>
                            <li className={'d-block d-md-none'}>
                                <NavDropdown.Item href="#" onClick={() => navigate('/all-artist')}>
                                    All Artist
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/terms-of-service')}>
                                    Terms Of Service
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/privacy-policy')}>
                                    Privacy Policy
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/copyright-policy')}>
                                    Copyright Policy
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/community-guidelines')}>
                                    Community Guideline
                                </NavDropdown.Item>
                            </li>
                            <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/cookie-preferences')}>
                                    Cookie Preferences
                                </NavDropdown.Item>
                            </li>
                            {/* <li>
                                <NavDropdown.Item href="#" onClick={() => navigate('/dmca')}>
                                    DMCA
                                </NavDropdown.Item>
                            </li> */}
                        </ul>
                    </Col>
                    <Col lg={2} sm={6} className={'mt-3 mt-lg-0'}>
                        <div className="mmTitle">
                            Api
                        </div>
                        <ul className={'apiItems'}>
                            <li>
                                <NavDropdown.Item
                                    href="#"
                                    onClick={() => navigate('/developer-guideline')}
                                    style={{
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    Developer Guideline
                                </NavDropdown.Item>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </div>

            <div className="mainFooter">
                <div className={'px-2 py-2 px-md-4 py-md-3'}>
                    <Row>
                        <Col md={7} lg={8} xxl={9} className={'align-self-center'}>
                            <ul className={'d-flex align-items-center mainFooterMenu mt-0 flex-wrap'}>
                                <li>
                                    <Nav.Link href={'/terms-of-service'}>Terms Of Service</Nav.Link>
                                </li>
                                <li>
                                    <Nav.Link href={'/about-us'}>About Us</Nav.Link>
                                </li>
                                <li>
                                    <Nav.Link href={'/privacy-policy'}>Privacy Policy</Nav.Link>
                                </li>
                            </ul>
                        </Col>
                        <Col md={5} lg={4} xxl={3}>
                            <div className="d-flex align-items-center mt-2 mt-sm-3 mt-md-0">
                                <h6 className={'pe-2 me-2 pe-lg-3 me-lg-3 lh-1 border-right m-0 text-white fw-semibold'}>Follow
                                    Us</h6>
                                <ul className={'d-flex align-items-center mt-0 socialMenu'}>
                                    <li>
                                        <Nav.Link
                                            href="https://www.facebook.com/BrainCraftLtd/"
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            <img
                                                src={FB}
                                                alt="img-fluid"
                                            />
                                        </Nav.Link>
                                    </li>

                                    <li>
                                        <Nav.Link
                                            href="https://twitter.com/BrainCraftLtd"
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            <img
                                                src={TW}
                                                alt="img-fluid"
                                            />
                                        </Nav.Link>
                                    </li>
                                    <li>
                                        <Nav.Link
                                            href="https://www.linkedin.com/company/brain-craft-ltd"
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            <img
                                                src={require('../../../assets/icons/linkdin.png')}
                                                alt="img-fluid"
                                            />
                                        </Nav.Link>
                                    </li>
                                    <li>
                                        <Nav.Link
                                            href="https://www.instagram.com/brain_craft_ltd/"
                                            target={'_blank'}
                                            rel={'noreferrer'}
                                        >
                                            <img
                                                src={require('../../../assets/icons/instagram.png')}
                                                alt="img-fluid"
                                            />
                                        </Nav.Link>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default MegaMenu;